import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useStateContext } from "../../../context/StateContext_US";
import { HashLink } from "react-router-hash-link";
import { useLocation } from "react-router-dom";
import {
  doc,
  setDoc,
  db,
  getDoc,
  serverTimestamp,
  addDoc,
  collection,
  functions,
  httpsCallable,
} from "../../../firebase";
// import { functions, httpsCallable } from "../../../firebase";
import Fade from "react-reveal/Fade";
import { useAuth } from "../../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import FeaturedProductRecent from "./FeaturedProductsBestSellers";

// import FeaturedProducts from "./FeaturedProducts";
// http://localhost:3000/success?
// payment_intent=pi_3KQk8UGL7n6A7ptg1JPDpwn4&
// payment_intent_client_secret=pi_3KQk8UGL7n6A7ptg1JPDpwn4_secret_LzPpnoFRE2deHoznsfa9sCApK&
// redirect_status=succeeded

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const Success = () => {
  console.log("FinishCheckoutUSA", sessionStorage.getItem("FinishCheckoutUSA"));
  const [orderId, setOrderId] = useState(null);
  let navigate = useNavigate();
  const [guest, setGuest] = useState(
    sessionStorage.getItem("checkout_guestPassword") ? true : false
  );

  let query = useQuery();
  const { currentUser } = useAuth();
  const { basket, taxPrice, emptyBasket } = useStateContext();
  const [err, setErr] = useState(null);

  const easyPostcreateShipment2 = httpsCallable(
    functions,
    "easyPostcreateShipment2"
  );

  console.log(
    "basket===> ",
    JSON.parse(sessionStorage.getItem("checkout_basket"))
  );

  console.log(
    sessionStorage.getItem("checkout_guestPassword"),
    sessionStorage.getItem("checkout_email"),
    sessionStorage.getItem("checkout_tax_rate"),
    sessionStorage.getItem("checkout_basket"),
    sessionStorage.getItem("checkout_taxprice"),
    sessionStorage.getItem("checkout_shippingOption"),
    sessionStorage.getItem("checkout_shippingPrice"),
    sessionStorage.getItem("checkout_total"),
    sessionStorage.getItem("checkout_subtotal"),
    sessionStorage.getItem("checkout_userUID")
  );

  let payment_intent = query.get("payment_intent");

  // console.log(payment_intent);
  // console.log("basket", basket);

  const orderid = require("order-id")("key");
  const id = orderid.generate();
  orderid.getTime(id);
  // console.log("orderid", id);

  console.log({
    email: sessionStorage.getItem("checkout_email"),
    taxRate: sessionStorage.getItem("checkout_tax_rate"),
    payment_intent: payment_intent,
    basket: sessionStorage.getItem("checkout_basket"),
    taxPrice: taxPrice,
    shippingOption: sessionStorage.getItem("checkout_shippingOption"),
    shippingPrice: sessionStorage.getItem("checkout_shippingPrice"),
    finalPrice: sessionStorage.getItem("checkout_total"),
    subtotal: sessionStorage.getItem("getSubtotal"),
    stripeUserId: sessionStorage.getItem("stripeUserId"),
    address: sessionStorage.getItem("checkout_shippingAddress"),
  });

  useEffect(() => {
    easyPostcreateShipment2({
      address_address: sessionStorage.getItem("checkout_shippingAddress"),
      address_apt: sessionStorage.getItem("checkout_shippingApt"),
      address_city: sessionStorage.getItem("checkout_shippingCity") + " ",
      address_state: sessionStorage.getItem("checkout_shippingState"),
      address_zipcode: sessionStorage.getItem("checkout_shippingZipcode"),
      address_firstname: sessionStorage.getItem("checkout_shippingFirstname"),
      address_lastname: sessionStorage.getItem("checkout_shippingLastname"),
    })
      .then((shipment) => {
        if (sessionStorage.getItem("FinishCheckoutUSA")) {
          addToDb(shipment);
        }
      })
      .catch((error) => console.log(error));
  }, []);

  const addToDb = async (shipment) => {
    setOrderId(id);
    const shipmentArr = {
      shipmentId: shipment.data.id,
      shipmentLabel: shipment.data.postage_label.label_url,
      selected_rate_carrier: shipment.data.selected_rate.carrier,
      selected_rate_carrier_account_id:
        shipment.data.selected_rate.carrier_account_id,
      selected_rate_carrier_created_at: shipment.data.selected_rate.created_at,
      selected_rate_delivery_date: shipment.data.selected_rate.delivery_date,
      selected_rate_delivery_date_guaranteed:
        shipment.data.selected_rate.delivery_date_guaranteed,
      selected_rate_delivery_days: shipment.data.selected_rate.delivery_days,
      tracker_public_url: shipment.data.tracker.public_url,
      tracking_code: shipment.data.tracking_code,
      usps_zone: shipment.data.usps_zone,
      tracker_id: shipment.data.tracker.id,
    };

    let arr;
    if (sessionStorage.getItem("checkout_userUID")) {
      arr = {
        email: sessionStorage.getItem("checkout_email"),
        taxRate: sessionStorage.getItem("checkout_tax_rate"),
        payment_intent: payment_intent,
        basket: sessionStorage.getItem("checkout_basket"),
        checkout_taxprice: sessionStorage.getItem("checkout_taxprice"),
        shippingOption: sessionStorage.getItem("checkout_shippingOption"),
        shippingPrice: sessionStorage.getItem("checkout_shippingPrice"),
        finalPrice: sessionStorage.getItem("checkout_total"),
        subtotal: sessionStorage.getItem("checkout_subtotal"),
        user_uid: sessionStorage.getItem("checkout_userUID"),
        created: serverTimestamp(),
        status: ["Preparing for shipment"],

        address_firstname: sessionStorage.getItem("checkout_shippingFirstname"),
        address_lastname: sessionStorage.getItem("checkout_shippingLastname"),
        address_address: sessionStorage.getItem("checkout_shippingAddress"),
        address_apt: sessionStorage.getItem("checkout_shippingApt"),
        address_city: sessionStorage.getItem("checkout_shippingCity"),
        address_state: sessionStorage.getItem("checkout_shippingState"),
        address_zipcode: sessionStorage.getItem("checkout_shippingZipcode"),
        shipment: shipmentArr,
      };
    } else {
      arr = {
        email: sessionStorage.getItem("checkout_email"),
        taxRate: sessionStorage.getItem("checkout_tax_rate"),
        payment_intent: payment_intent,
        basket: sessionStorage.getItem("checkout_basket"),
        checkout_taxprice: sessionStorage.getItem("checkout_taxprice"),
        shippingOption: sessionStorage.getItem("checkout_shippingOption"),
        shippingPrice: sessionStorage.getItem("checkout_shippingPrice"),
        finalPrice: sessionStorage.getItem("checkout_total"),
        subtotal: sessionStorage.getItem("checkout_subtotal"),
        guestPassword: sessionStorage.getItem("checkout_guestPassword"),
        created: serverTimestamp(),
        status: ["Preparing for shipment"],

        address_firstname: sessionStorage.getItem("checkout_shippingFirstname"),
        address_lastname: sessionStorage.getItem("checkout_shippingLastname"),
        address_address: sessionStorage.getItem("checkout_shippingAddress"),
        address_apt: sessionStorage.getItem("checkout_shippingApt"),
        address_city: sessionStorage.getItem("checkout_shippingCity"),
        address_state: sessionStorage.getItem("checkout_shippingState"),
        address_zipcode: sessionStorage.getItem("checkout_shippingZipcode"),
        shipment: shipmentArr,
      };
    }

    await setDoc(doc(db, "US_orders", id), arr)
      .then(async (res) => {
        addToUser();
      })
      .catch((err) => {
        console.log(err);
        setErr("There is a technical issue. Please try after 10 minutes. ");
      });

    return () => {
      removeAll();
    };
  };

  const removeAll = () => {
    console.log("removeAll is called!!!");
    emptyBasket();
    sessionStorage.removeItem("checkout_email");
    sessionStorage.removeItem("checkout_tax_rate");
    sessionStorage.removeItem("checkout_shippingOption");
    sessionStorage.removeItem("checkout_shippingPrice");
    sessionStorage.removeItem("checkout_total");
    sessionStorage.removeItem("getSubtotal");
    sessionStorage.removeItem("checkout_subtotal");

    sessionStorage.removeItem("FinishCheckoutUSA");
    if (sessionStorage.getItem("checkout_guestPassword"))
      sessionStorage.removeItem("checkout_guestPassword");
  };

  const addToUser = async () => {
    emptyBasket();
    let basket = JSON.parse(sessionStorage.getItem("checkout_basket"));
    // reduce the number of products
    basket.map(async (item) => {
      const ref = doc(db, "products", item.id);
      const docSnap = await getDoc(ref);
      if (docSnap.exists()) {
        console.log("Document data:", docSnap.data());
        let quantity = docSnap.data().quantity;
        let newQuantity = quantity - item.quantity;

        setDoc(ref, { quantity: newQuantity }, { merge: true });
      }
    });

    // 회원 주문일때
    if (sessionStorage.getItem("checkout_userUID")) {
      const docRef = doc(
        db,
        "users",
        sessionStorage.getItem("checkout_userUID")
      );
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        console.log("Document data:", docSnap.data());
        console.log("Basket data:", basket);

        // 회원이 예전 산 기록이 있을때
        if (docSnap.data().purchases) {
          console.log("purchase found");
          let purchases = docSnap.data().purchases;
          let res = basket?.map((item) => {
            if (docSnap.data().purchases.indexOf(item.id) < 0) {
              purchases.push(item.id);
            }
          });
          await setDoc(docRef, { purchases: purchases }, { merge: true });
          removeAll();
          // 회원이 예전 산 기록이 없을때
        } else {
          let purchases = [];
          basket?.map((item) => {
            console.log("item.id", item.id);
            purchases.push(item.id);
          });
          console.log("purchases", purchases);
          const docRef = doc(
            db,
            "users",
            sessionStorage.getItem("checkout_userUID")
          );
          await setDoc(docRef, { purchases: purchases }, { merge: true });
          removeAll();
        }
      }
    }
    removeAll();
  };
  console.log("FinishCheckoutUSA", sessionStorage.getItem("FinishCheckoutUSA"));
  return (
    <Box
      sx={{
        py: 10,
        pt: 5,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Fade delay="300">
        <h1>
          <CheckCircleOutlineIcon sx={{ fontSize: "70px", color: "#a2cf6e" }} />
        </h1>
        <Box sx={{ fontSize: "20px", pt: 2 }}>Thank you</Box>
        <Box sx={{ pt: 4, fontSize: "14px", textAlign: "center" }}>
          Your order was completed successfully. <br />
          <br />
          You will receive an order confirmation email shortly.
        </Box>

        <Box sx={{ pt: 3, fontWeight: 600 }}>
          {" "}
          {orderId ? "Order #: " + orderId : null}
        </Box>
        <Box
          sx={{
            pt: 3,
            display: "flex",
          }}
        ></Box>

        <Box sx={{ width: "400px", pb: 4 }}>
          <HashLink to="/products-cleansing">
            <button className="custom_btn">Continue Shopping</button>
          </HashLink>
          {guest ? null : (
            <HashLink to="/dashboard">
              <button
                className="custom_btn_whitebg"
                style={{ marginTop: "20px" }}
              >
                Order History
              </button>
            </HashLink>
          )}
        </Box>
      </Fade>

      <FeaturedProductRecent width={7} />
    </Box>
  );
};

export default Success;
